webpackJsonp(["conditioner32"],{

/***/ "./src/js/ui/offset-anchor.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = offsetAnchor;
function offsetAnchor($anchor) {

  var targetId = $anchor.getAttribute('data-offset-target');
  if (targetId) {
    var $target = document.getElementById(targetId);
    if ($target) {
      $anchor.setAttribute('style', 'position: absolute; top: -' + $target.offsetHeight + 'px');
      window.addEventListener('scroll', function (e) {
        $anchor.style.top = '-' + $target.offsetHeight + 'px';
      });
    }
  }
}

/***/ })

});


// WEBPACK FOOTER //
// conditioner32.93cfa5dfcb1417eb7398.js